import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'lp-components'
import { ExternalLink } from 'components'
import { PATH, makePath } from 'config'

const propTypes = {
  lastFour: PropTypes.string,
  openEditView: PropTypes.func.isRequired,
}

function PaymentMethod({ lastFour, openEditView }) {
  return (
    <div className="row">
      <div className="col-6">
        <h3>Payment Method</h3>
        <Button onClick={openEditView} className="link-primary">
          (Edit)
        </Button>
        {lastFour && <p>Ending in {lastFour}</p>}
      </div>
      <div className="col-6 align-right">
        <ExternalLink
          href={makePath(
            PATH.SEATOW,
            PATH.MEMBERSHIP,
            PATH.MEMBERSHIP_AGREEMENT,
          )}
          className="link-small"
        >
          Auto Renew Agreement
        </ExternalLink>
      </div>
    </div>
  )
}

PaymentMethod.propTypes = propTypes

export default PaymentMethod
